import FieldSet from '../../FieldSet';
import { RemainingEstimate } from './RemainingEstimate';
import { RemainingEstimateWithIcon } from './RemainingEstimateWithIcon';

export class RemainingEstimateFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [RemainingEstimate, RemainingEstimateWithIcon];
  }

  get title() {
    return 'Remaining estimate';
  }
}
